import { inject, Injectable } from '@angular/core';

import { PreferencesService } from './preferences.service';

@Injectable({
	providedIn: 'root',
})
export class ThemeService {
	public darkMode: boolean = false;
	private readonly preferencesService = inject(PreferencesService);

	constructor() {
		this.checkDarkMode();
	}

	public checkDarkMode(): void {
		const darkModePreference = this.preferencesService.getPreference<boolean>('darkMode');

		if (darkModePreference === true) {
			this.setDarkTheme(true);
		} else if (darkModePreference === undefined && window.matchMedia('(prefers-color-scheme: dark)').matches) {
			this.setDarkTheme(true);
		}
	}

	public toggleDarkTheme(): void {
		this.setDarkTheme(!this.darkMode);
	}

	private setDarkTheme(isDark: boolean): void {
		this.darkMode = isDark;
		if (isDark) {
			document.body.classList.add('dark-theme');
		} else {
			document.body.classList.remove('dark-theme');
		}
		this.preferencesService.setPreference({ darkMode: this.darkMode });
	}
}
